import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import DownloadIcon from '../../ui/icons/DownloadIcon'
import XmarkIcon from '../../ui/icons/XmarkIcon'
import useIssueExport from '../hooks/useIssueExport'

const GROUP_CLASS = 'tw:inline-flex tw:items-center tw:gap-2.5 tw:pr-3 tw:bg-white '
  + 'tw:rounded-lg! tw:border tw:border-solid tw:border-gray-300 tw:overflow-hidden! '
  + 'tw:shadow-[0_0_8px_0_rgba(0,0,0,0.04)]'
const COUNT_CLASS = 'tw:flex tw:items-center tw:px-2.5 tw:py-1.5 tw:border-0 tw:border-r '
  + 'tw:border-solid tw:border-gray-300! tw:text-sm tw:font-medium tw:text-gray-900'
const ACTION_CLASS = 'tw:inline-flex tw:items-center tw:gap-2 tw:bg-transparent tw:border-0 '
  + 'tw:text-sm tw:font-normal tw:text-gray-900 tw:cursor-pointer tw:hover:font-semibold '
  + 'tw:disabled:opacity-50 tw:disabled:cursor-not-allowed'
const SEPARATOR_CLASS = 'tw:w-px tw:h-5 tw:bg-gray-300 tw:shrink-0'
const CLEAR_CLASS = 'tw:inline-flex tw:items-center tw:justify-center tw:bg-transparent '
  + 'tw:border-0 tw:text-gray-600 tw:hover:text-gray-800 tw:cursor-pointer'
const DOWNLOAD_ICON_CLASS = 'tw:w-3.5 tw:h-3.5'
const CLEAR_ICON_CLASS = 'tw:w-5 tw:h-5'

const EMPTY_SELECTION = new Set()

const SelectionToolbar = ({
  collectId, toastContainerId, selectedIds, onClear,
  draftId = null, search = '', issueStatus = null, issueContent = null
}) => {
  const { exportTo, exporting } = useIssueExport(collectId, toastContainerId)
  const suffix = selectedIds.size > 1 ? 's' : ''
  const label = `${selectedIds.size} élément${suffix} sélectionné${suffix}`

  const exportExcel = useCallback(() => {
    exportTo('xlsx', { draftId, search, issueStatus, issueContent, selectedIds })
  }, [exportTo, draftId, search, issueStatus, issueContent, selectedIds])

  const exportPdf = useCallback(() => {
    exportTo('pdf', { draftId, search, issueStatus, issueContent, selectedIds })
  }, [exportTo, draftId, search, issueStatus, issueContent, selectedIds])

  return (
    <div className={GROUP_CLASS}>
      <span className={COUNT_CLASS}>{label}</span>
      <button className={ACTION_CLASS} disabled={exporting} type="button" onClick={exportExcel}>
        <DownloadIcon className={DOWNLOAD_ICON_CLASS} />
        Exporter en Excel
      </button>
      <span aria-hidden="true" className={SEPARATOR_CLASS} />
      <button className={ACTION_CLASS} disabled={exporting} type="button" onClick={exportPdf}>
        <DownloadIcon className={DOWNLOAD_ICON_CLASS} />
        Exporter en PDF
      </button>
      <span aria-hidden="true" className={SEPARATOR_CLASS} />
      <button
        aria-label="Annuler la sélection"
        className={CLEAR_CLASS}
        type="button"
        onClick={onClear}
      >
        <XmarkIcon className={CLEAR_ICON_CLASS} />
      </button>
    </div>
  )
}

SelectionToolbar.propTypes = {
  collectId: PropTypes.number.isRequired,
  draftId: PropTypes.number,
  issueContent: PropTypes.string,
  issueStatus: PropTypes.string,
  onClear: PropTypes.func.isRequired,
  search: PropTypes.string,
  selectedIds: PropTypes.instanceOf(Set),
  toastContainerId: PropTypes.string.isRequired
}

SelectionToolbar.defaultProps = {
  draftId: null,
  issueContent: null,
  issueStatus: null,
  search: '',
  selectedIds: EMPTY_SELECTION
}

export default SelectionToolbar
